<template>
  <div class="home">
    <Header @refreshHome="refreshHome" @refreshHomePeriod="refreshHomePeriod" @refreshHomeYear="refreshHomeYear"
      @showSelectedYear="showSelectedYear" ref="header"/>
    <router-view ref="childComponent"></router-view>
  </div>
</template>

<style lang="less">
@media screen and (min-width: 769px) {
  .home {
    width: 480Px;
    margin: 0 auto
  }
}

.home {
  margin-top: 10%;
}
</style>

<script>
import Header from './Header.vue';
export default {
  name: 'Home',
  data() {
    return {
      title: ''
    }
  },
  components: {
    Header: Header,
  },
  methods: {
    refreshHome() {
      this.$refs.childComponent.initWrap();
    },
    refreshHomePeriod(period) {
      this.$refs.childComponent.initWrap(period);
    },
    refreshHomeYear(year) {
      this.$refs.header.setYear(year);
      this.$refs.childComponent.initWrap(year);
    },
    showSelectedYear(year) {
      this.$emit("showSelectedYear", year);
    }
  }
}
</script>